import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@restworld/utils-common';
import { useTaxonomyService } from '@restworld/data-services';

export interface JobListingOccupationOption {
  id: string;
  label: string;
}

/**
 * Fetches the taxonomy occupations used to populate the JP listing occupation
 * filter. Returns a stable `{ id, label }` list sorted alphabetically by label,
 * with deprecated and unlabeled occupations filtered out.
 */
function useEmployerJobListingOccupations(staleTime = Infinity) {
  const taxonomyService = useTaxonomyService();

  return useQuery({
    queryKey: [QUERY_KEYS.TAXONOMY.OCCUPATIONS],
    queryFn: () => taxonomyService.indexOccupations(),
    select: (response): JobListingOccupationOption[] =>
      (response.data || [])
        .filter((occupation) => !occupation.deprecated && occupation.label_it?.label)
        .map((occupation) => ({ id: occupation.id.toString(), label: occupation.label_it.label }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    staleTime,
  });
}

export default useEmployerJobListingOccupations;
